var USER_PROFILE_REFERRAL_URL = '/user/referral';
export { USER_PROFILE_REFERRAL_URL };